import { FC } from 'react';

import { IcDelete16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import styles from './DeletedByMePayload.styles.m.css';

export const DeletedByMePayload: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.text}>
      <IconView
        Icon={IcDelete16Icon}
        className={styles.icon}
        size={IconViewSizes.Small}
      />
      {t('common_message_deleted_for_me')}
    </div>
  );
};
